export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_09.bbd8fe59.mp4";